import { Check, Zap, Star, Shield, TrendingUp, MessageSquare, FileText, ChevronRight, Gift } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Logo } from '../components/Logo';

export default function TarificationPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#121212] text-white font-sans selection:bg-[#FF5C00]/30">

      {/* Nav */}
      <nav className="border-b border-white/5 px-6 py-4 flex items-center justify-between">
        <button onClick={() => navigate('/')} className="cursor-pointer">
          <Logo />
        </button>
        <div className="flex gap-4">
          <button
            onClick={() => navigate('/exposants')}
            className="text-sm text-gray-400 hover:text-white transition-colors"
          >
            Je suis exposant
          </button>
          <button
            onClick={() => navigate('/home')}
            className="text-sm bg-[#FF5C00] text-white px-4 py-2 rounded-full hover:bg-[#FF5C00]/90 transition-colors font-medium"
          >
            Commencer
          </button>
        </div>
      </nav>

      {/* Hero */}
      <div className="relative py-24 overflow-hidden border-b border-white/5 text-center">
        <div className="absolute inset-0 bg-gradient-to-tr from-[#FF5C00]/10 via-transparent to-[#00A3FF]/10" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[400px] bg-[#FF5C00] opacity-15 blur-[150px] rounded-full pointer-events-none" />
        <div className="relative max-w-3xl mx-auto px-6">
          <div className="inline-flex items-center gap-2 bg-[#FF5C00]/10 border border-[#FF5C00]/30 text-[#FF5C00] text-xs font-bold px-3 py-1.5 rounded-full mb-8 tracking-widest uppercase">
            <Zap className="w-3 h-3" />
            Offre de lancement
          </div>
          <h1 className="text-5xl md:text-6xl font-black tracking-tight mb-6">
            Tarification simple,<br className="hidden md:block" /> transparente.
          </h1>
          <p className="text-xl text-gray-400 max-w-xl mx-auto">
            Festin se rémunère exclusivement auprès de l'exposant. L'organisateur ne paie rien.
          </p>
        </div>
      </div>

      <main className="max-w-6xl mx-auto px-6 py-20">

        {/* Qui paie quoi */}
        <div className="mb-20">
          <p className="text-xs font-bold tracking-widest uppercase text-gray-500 mb-4 text-center">Qui paie quoi</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="bg-white/5 border border-white/10 rounded-2xl p-6 flex items-start gap-4">
              <div className="w-10 h-10 bg-[#FF5C00]/15 rounded-xl flex items-center justify-center shrink-0">
                <span className="text-[#FF5C00] font-black text-sm">EXP</span>
              </div>
              <div>
                <h3 className="font-bold text-white mb-1">Exposant (la marque)</h3>
                <p className="text-sm text-gray-400">Paie les frais Festin (forfait ou %) + le prix du stand à l'organisateur si applicable.</p>
              </div>
            </div>
            <div className="bg-white/5 border border-white/10 rounded-2xl p-6 flex items-start gap-4">
              <div className="w-10 h-10 bg-[#00A3FF]/15 rounded-xl flex items-center justify-center shrink-0">
                <span className="text-[#00A3FF] font-black text-sm">ORG</span>
              </div>
              <div>
                <h3 className="font-bold text-white mb-1">Organisateur</h3>
                <p className="text-sm text-gray-400">Ne paie rien à Festin. Reçoit 100% du prix du stand directement sur son compte.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Deux cas tarifaires */}
        <div className="mb-20">
          <h2 className="text-3xl font-black text-center mb-3">Deux situations, une règle simple</h2>
          <p className="text-gray-400 text-center mb-12">Le tarif Festin dépend uniquement du prix du stand fixé par l'organisateur.</p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

            {/* Cas A */}
            <div className="relative bg-[#1A1A1A] border border-white/10 rounded-3xl p-8 overflow-hidden">
              <div className="absolute top-0 right-0 w-48 h-48 bg-[#FF5C00] opacity-5 blur-[80px]" />
              <div className="text-xs font-bold tracking-widest text-[#FF5C00] uppercase mb-6">Cas A — Stand gratuit</div>
              <p className="text-gray-400 text-sm mb-8">L'organisateur ne facture pas d'emplacement. L'exposant ne paie que les frais Festin.</p>

              {/* Prix lancement */}
              <div className="relative mb-4">
                <div className="absolute -top-2 right-0 bg-[#FF5C00] text-white text-[10px] font-black px-2 py-0.5 rounded-full tracking-widest uppercase">Lancement</div>
                <div className="bg-[#FF5C00]/10 border border-[#FF5C00]/30 rounded-2xl p-5">
                  <div className="flex items-end gap-2 mb-1">
                    <span className="text-4xl font-black text-white">29€</span>
                    <span className="text-gray-400 mb-1">HT par festival</span>
                  </div>
                  <p className="text-xs text-[#FF5C00]">Offre limitée aux premières inscriptions</p>
                </div>
              </div>

              {/* Prix standard */}
              <div className="bg-white/5 border border-white/10 rounded-2xl p-5">
                <div className="flex items-end gap-2 mb-1">
                  <span className="text-3xl font-black text-gray-400 line-through">49€</span>
                  <span className="text-gray-500 mb-1">HT — tarif public</span>
                </div>
                <p className="text-xs text-gray-500">Après la période de lancement</p>
              </div>
            </div>

            {/* Cas B */}
            <div className="relative bg-[#1A1A1A] border border-white/10 rounded-3xl p-8 overflow-hidden">
              <div className="absolute top-0 right-0 w-48 h-48 bg-[#00A3FF] opacity-5 blur-[80px]" />
              <div className="text-xs font-bold tracking-widest text-[#00A3FF] uppercase mb-6">Cas B — Stand payant</div>
              <p className="text-gray-400 text-sm mb-8">L'organisateur fixe un prix d'emplacement. Les frais Festin s'ajoutent selon un seuil.</p>

              <div className="space-y-3">
                {/* Forfait */}
                <div className="bg-white/5 border border-white/10 rounded-2xl p-5">
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-xs font-bold text-gray-400 uppercase tracking-wider">Stand ≤ 164€ / jour</span>
                    <span className="bg-white/10 text-white text-xs font-bold px-2 py-0.5 rounded-full">Forfait</span>
                  </div>
                  <div className="flex items-end gap-2">
                    <span className="text-3xl font-black text-white">+49€</span>
                    <span className="text-gray-400 mb-1">HT</span>
                  </div>
                  <p className="text-xs text-gray-500 mt-1">Ex : stand 100€/j → total exposant 149€ HT</p>
                </div>
                {/* Pourcentage */}
                <div className="bg-white/5 border border-white/10 rounded-2xl p-5">
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-xs font-bold text-gray-400 uppercase tracking-wider">Stand ≥ 164,50€ / jour</span>
                    <span className="bg-[#00A3FF]/20 text-[#00A3FF] text-xs font-bold px-2 py-0.5 rounded-full">Pourcentage</span>
                  </div>
                  <div className="flex items-end gap-2">
                    <span className="text-3xl font-black text-white">+30%</span>
                    <span className="text-gray-400 mb-1">du montant HT</span>
                  </div>
                  <p className="text-xs text-gray-500 mt-1">Ex : stand 200€/j → frais Festin 60€ HT</p>
                </div>
              </div>
            </div>
          </div>

          {/* Note transparence */}
          <div className="mt-6 flex items-start gap-3 bg-white/3 border border-white/5 rounded-2xl px-6 py-4">
            <Shield className="w-4 h-4 text-[#FF5C00] mt-0.5 shrink-0" />
            <p className="text-sm text-gray-400">
              <span className="text-white font-medium">Transparence totale.</span>{' '}
              Le détail prix stand / frais Festin est toujours affiché séparément avant validation du paiement — jamais un total opaque.
            </p>
          </div>
        </div>

        {/* Ce que tu gagnes */}
        <div className="mb-20">
          <h2 className="text-3xl font-black text-center mb-3">Ce que ça t'apporte</h2>
          <p className="text-gray-400 text-center mb-12">Pour les exposants inscrits sur Festin.</p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            {[
              {
                icon: <TrendingUp className="w-5 h-5 text-[#FF5C00]" />,
                title: 'Accès & visibilité',
                items: [
                  'Catalogue de festivals actifs cherchant des exposants',
                  'Profil visible par tous les organisateurs du réseau',
                  'Positionnement prioritaire dans les suggestions',
                ],
              },
              {
                icon: <Zap className="w-5 h-5 text-[#FF5C00]" />,
                title: 'Simplicité opérationnelle',
                items: [
                  'Candidature en 2 clics, sans rédiger un message',
                  'Statut de candidature en temps réel (acceptée / refusée)',
                  'Paiement, contact organisateur et factures au même endroit',
                ],
              },
              {
                icon: <MessageSquare className="w-5 h-5 text-[#FF5C00]" />,
                title: 'Fini le chaos',
                items: [
                  'Plus de mails perdus ni de DMs Instagram sans réponse',
                  'Toute la conversation et le suivi tracés sur la plateforme',
                  'Facture PDF générée automatiquement après chaque paiement',
                ],
              },
              {
                icon: <Gift className="w-5 h-5 text-[#FF5C00]" />,
                title: 'Parrainage',
                items: [
                  '10€ offerts à chaque exposant que tu parraines',
                  '10€ de crédit pour toi à chaque filleul confirmé (jusqu\'à 50€)',
                  'Un lien unique à partager, généré en un clic',
                ],
              },
            ].map(({ icon, title, items }) => (
              <div key={title} className="bg-[#1A1A1A] border border-white/5 rounded-3xl p-7 hover:border-[#FF5C00]/20 transition-colors">
                <div className="w-10 h-10 bg-[#FF5C00]/10 rounded-xl flex items-center justify-center mb-5">
                  {icon}
                </div>
                <h3 className="font-bold text-white mb-4">{title}</h3>
                <ul className="space-y-3">
                  {items.map((item) => (
                    <li key={item} className="flex items-start gap-3">
                      <Check className="w-4 h-4 text-[#FF5C00] mt-0.5 shrink-0" />
                      <span className="text-sm text-gray-400">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Score & exposition */}
        <div className="mb-20">
          <div className="bg-gradient-to-br from-[#1A1A1A] to-[#111] border border-white/10 rounded-3xl p-10 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-64 h-64 bg-[#FF5C00] opacity-5 blur-[100px]" />
            <div className="relative">
              <div className="flex items-center gap-2 mb-6">
                <Star className="w-5 h-5 text-[#FF5C00]" />
                <span className="text-xs font-bold tracking-widest uppercase text-[#FF5C00]">Exposition n°1</span>
              </div>
              <h2 className="text-2xl font-black mb-3">Ton score booste ta visibilité</h2>
              <p className="text-gray-400 mb-8 max-w-xl">
                Le classement n'est pas au plus offrant. Il repose sur la qualité réelle de ton profil et ta réputation — garantissant aux organisateurs des recommandations fiables.
              </p>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {[
                  { label: 'Complétion du profil', pct: '20%', detail: 'Photos, vidéo, dimensions, catégorie' },
                  { label: 'Réputation', pct: '40%', detail: 'Notes des organisateurs' },
                  { label: 'Fiabilité', pct: '25%', detail: 'Taux de présence, paiements à jour' },
                  { label: 'Mise en avant', pct: '15%', detail: 'Boost optionnel, plafonné' },
                ].map(({ label, pct, detail }) => (
                  <div key={label} className="bg-white/5 rounded-2xl p-4">
                    <div className="text-2xl font-black text-[#FF5C00] mb-1">{pct}</div>
                    <div className="text-sm font-bold text-white mb-1">{label}</div>
                    <div className="text-xs text-gray-500">{detail}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <h2 className="text-3xl font-black mb-4">Prêt à rejoindre la bêta ?</h2>
          <p className="text-gray-400 mb-8">Places limitées au tarif de lancement.</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={() => navigate('/home')}
              className="inline-flex items-center gap-2 bg-[#FF5C00] text-white px-8 py-4 rounded-full font-bold text-base hover:bg-[#FF5C00]/90 transition-colors"
            >
              Créer mon profil exposant
              <ChevronRight className="w-4 h-4" />
            </button>
            <button
              onClick={() => navigate('/contact')}
              className="inline-flex items-center gap-2 bg-white/5 border border-white/10 text-white px-8 py-4 rounded-full font-bold text-base hover:bg-white/10 transition-colors"
            >
              Poser une question
            </button>
          </div>
        </div>

      </main>

      <Footer />
    </div>
  );
}
